var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticStyle:{"max-width":"1120px"},attrs:{"column":""}},[_c('v-layout',{staticStyle:{"padding":"0px"},attrs:{"row":""}},[_c('div',{staticStyle:{"margin":"0","padding":"0"},attrs:{"id":"game_container"}})]),_c('message-log')],1)}
var staticRenderFns = []

export { render, staticRenderFns }